import { HasAccess } from './HasAccess';
import { HasAccessProps } from './Permissions.decl';

export const withAccess = <TProps extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<TProps>,
  hasAccessProps: Omit<HasAccessProps, 'children'>
) =>
  function WithAccessWrapper(origProps: TProps) {
    return (
      <HasAccess {...hasAccessProps}>
        <WrappedComponent {...origProps} />
      </HasAccess>
    );
  };
